module.exports = __webpack_public_path__ + "img/fuwu_01.48873b2d.png";